module.exports = __webpack_public_path__ + "img/topbanner.6fa46374.svg";